import DonorCard from "../../DonorCard.js";

function ReceiptModal({
  showPdfModal,
  setShowPdfModal,
  setReceiptDetails,
  receiptRef,
  receiptDetails,
  downloadPdf,
}) {
  if (!showPdfModal) return null;

  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-xl modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Receipt</h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => {
                setShowPdfModal(false);
                setReceiptDetails("");
              }}
            ></button>
          </div>

          <DonorCard ref={receiptRef} receiptDetails={receiptDetails} />

          <div className="modal-footer">
            <button className="btn btn-success" onClick={downloadPdf}>
              Download PDF
            </button>
            <button
              className="btn btn-secondary"
              onClick={() => setShowPdfModal(false)}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReceiptModal;
